import { Component } from 'react'
import { connect } from 'redaction'
import { compose, links } from 'common/helpers'

import injectGlobals from 'decorators/injectGlobals'


class HasAuth extends Component {

  UNSAFE_componentWillMount() {
    const { isLoggedIn, location: { pathname, search }, redirect } = this.props

    if (!isLoggedIn) {
      const locationPath  = encodeURIComponent(`${pathname}${search}`)
      const redirectLink  = locationPath ? `${links.login}?redirect=${locationPath}` : links.login

      redirect(redirectLink)
    }
  }

  render() {
    const { children, isLoggedIn } = this.props

    return isLoggedIn ? children : null
  }
}


export default compose(
  injectGlobals(({ redirect }) => ({
    redirect,
  })),
  connect({
    isLoggedIn: 'models.me.isLoggedIn',
  })
)(HasAuth)
